import { useMemo } from "react";
import type { IntervieweeDetail, MediaPreview } from "../../../domain/contracts";
import { buildDownloadItemsFromGroups, buildPreviewByAssetId } from "../../../services/evidenceGroups";

export type IntervieweeEvidenceState = {
  evidenceGroups: IntervieweeDetail["evidenceGroups"];
  previewByAssetId: Map<string, MediaPreview>;
  downloadItems: ReturnType<typeof buildDownloadItemsFromGroups>;
  evidence: IntervieweeDetail["evidence"];
};

export function useIntervieweeEvidence(
  intervieweeDetail: IntervieweeDetail | null,
  mediaPreviews: MediaPreview[],
): IntervieweeEvidenceState {
  return useMemo(() => {
    const evidence = intervieweeDetail?.evidence ?? [];
    const evidenceGroups = intervieweeDetail?.evidenceGroups ?? [];

    return {
      evidence,
      evidenceGroups,
      previewByAssetId: buildPreviewByAssetId(evidence, mediaPreviews),
      downloadItems: buildDownloadItemsFromGroups(evidenceGroups),
    };
  }, [intervieweeDetail, mediaPreviews]);
}
